import { P2GBox } from '@parcel2go/core-ui';
import { Suspense } from 'react';

const MobileLayout = ({ children }: { children: React.ReactNode }) => (
  <Suspense>
    <P2GBox sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>{children}</P2GBox>
  </Suspense>
);

export default MobileLayout;
